module.exports = __webpack_public_path__ + "img/freezingrain.8bdf47fe.png";